import * as React from 'react'
import * as Redux from 'react-redux'

import * as model from '@owl-nest/models'

import * as modalAction from '../../../../actions/modal'
import * as projectModel from '../../../models/project'
import { RootState } from '../../../../reducers'
import * as modalReducer from '../../../../reducers/modals/rewardModal'

import { PostCampaignModal } from './PostCampaignModal'
import { RewardModal } from './RewardModal'

export function RewardModals(): React.ReactElement<unknown> {
  const dispatch = Redux.useDispatch()

  const project = Redux.useSelector<RootState, projectModel.Project>((state) => state.application.project.data)
  const modal = Redux.useSelector<RootState, modalReducer.State>((state) => state.application.rewardModal)

  const hideRewardModal = model.project.isFinished<projectModel.ExtraFields>(project) || project.is_cancelled
  const sharedRewardId = modal.rewardId

  React.useEffect(() => {
    // check if we need to show post campaign modal
    // show this modal if project is finished, and post campaign link is set
    // and if user have a selected reward in url
    if (hideRewardModal && sharedRewardId.length > 0) {
      dispatch(modalAction.toggleModalPostCampaign(true))
    }
  }, [sharedRewardId])

  return (
    <>
      {!hideRewardModal && <RewardModal />}
      <PostCampaignModal />
    </>
  )
}
